import React, { useContext } from "react";
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import ListSubheader from '@material-ui/core/ListSubheader';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { Link as RouterLink } from 'react-router-dom';
import SvgIcon from '@material-ui/core/SvgIcon';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import { ReactComponent as HomeIcon } from './theme/menuicons/006-home.svg';
import { ReactComponent as CatalogIcon } from './theme/menuicons/024-online learning.svg';
import { ReactComponent as ConstructorIcon } from './theme/menuicons/036-analysis.svg';
import { ReactComponent as ManageIcon } from './theme/menuicons/040-configuration.svg';
import { ReactComponent as StudyRecIcon } from './theme/menuicons/031-online.svg';
import { ReactComponent as ScheduleIcon } from './theme/menuicons/013-time.svg';
import { ReactComponent as OprosIcon } from './theme/menuicons/018-review.svg';
import { ReactComponent as ServiceIcon } from './theme/menuicons/029-configuration.svg';
import SecurityContext from "./SecurityContext";

function ListItemLink(props) {
  const { icon, primary, to, iconclassname } = props;

  const renderLink = React.useMemo(
    () =>
      React.forwardRef((itemProps, ref) => (
        <RouterLink to={to} {...itemProps} innerRef={ref} />
      )),
    [to],
  );

  return (
    <li>
      <ListItem button component={renderLink}>
        {icon ? <ListItemIcon className={iconclassname}>{icon}</ListItemIcon> : null}
        <ListItemText primary={primary} />
      </ListItem>
    </li>
  );
}

const useStyles = makeStyles({
  list: {
    width: 250,
    paddingTop: '65px',
  },
  fullList: {
    width: 'auto',
  },
  menuitemIcon: {
    minWidth: '32px',
    marginRight: '8px',
    '& svg':{
      width: '32px',
      height: '32px'
    }
  },
  nested: {
    paddingLeft: '32px',
  },
});

export default function AppSidebar({ history, opened, setOpen }) {
  const classes = useStyles();

  const [submenuOpen, submenusetOpen] = React.useState(true);
  const [serviceMenuOpen, setServiceMenuOpen] = React.useState(false);

  const handleSubmenuClick = () => {
    setOpen(true);
    submenusetOpen(!submenuOpen);
  };

  const handleServiceMenuClick = () => {
    setOpen(true);
    setServiceMenuOpen(!serviceMenuOpen);
  };

  let securityContext = useContext(SecurityContext);
  let isAdmin = securityContext.hasRole('admin');
  let isStaff = securityContext.hasRole('staff');
  let isContractor = securityContext.hasRole('contractor');
  let isCustomer = securityContext.hasRole('customer');
  let isEmployer = securityContext.hasRole('employer');
  let isCurator = securityContext.hasRole('curator');
  let isExpert = securityContext.hasRole('expert');
  let isDeveloper = securityContext.hasRole('developer');
  let isQuizDeveloper = securityContext.hasRole('quiz_developer');

  return (
    <div>
      <Drawer open={opened} onClose={() => setOpen(false)}>
        <div
            className={classes.list}
            role="presentation"
            onClick={() => setOpen(false)}
            onKeyDown={() => setOpen(false)}
        >
          <List aria-label="main mailbox folders" component="nav">
            {(isAdmin || isStaff || isCurator) &&
            <ListItemLink to="/work/app/dashboard" primary="Главная" icon={<HomeIcon />} iconclassname={classes.menuitemIcon}/>
            }
            {/*(isAdmin || isStaff) &&
            <ListItemLink to="/work/app/catalog" primary="Каталог ОП" icon={<CatalogIcon />} iconclassname={classes.menuitemIcon} />
            */}
            {(isAdmin || isStaff || isExpert || isDeveloper) &&
            <ListItemLink to="/work/app/constructor" primary="Конструктор КиОП" icon={<ConstructorIcon />}  iconclassname={classes.menuitemIcon}/>
            }
            {(isAdmin || isStaff || isCurator) &&
            <ListItemLink to="/work/app/manage/resources" primary="Управление ООП" icon={<ManageIcon />}  iconclassname={classes.menuitemIcon} />
            }
            {(isAdmin || isStaff || isContractor) &&
            <ListItemLink to="/work/app/study" primary="Запись на обучение" icon={<StudyRecIcon />}  iconclassname={classes.menuitemIcon}/>
            }
            {(isAdmin || isStaff || isContractor || isCustomer) &&
            <ListItemLink to="/work/app/schedule" primary="Расписание ЦОПП" icon={<ScheduleIcon />}  iconclassname={classes.menuitemIcon}/>
            }
            {(isAdmin || isStaff || isQuizDeveloper) &&
            <ListItemLink to="/work/app/quiz" primary="Опросы" icon={<OprosIcon />}  iconclassname={classes.menuitemIcon}/>
            }
            {(isAdmin || isStaff  ) &&
            <ListItem button  onClick={handleServiceMenuClick}>
              <ListItemIcon className={classes.menuitemIcon}><ServiceIcon /></ListItemIcon>
              <ListItemText primary="Сервис" />
              {serviceMenuOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            }
            <Collapse in={serviceMenuOpen} timeout="auto" unmountOnExit>
              <List className={classes.nested} component="div" disablePadding>
                {(isAdmin || isStaff) &&
                <ListItemLink to="/work/app/service/question-request" primary="Вопросы с сайта" />}
                {(isAdmin  ) &&
                <ListItemLink to="/work/app/dict" primary="Справочники" />}
              </List>
            </Collapse>
          </List>
        </div>
      </Drawer>
    </div>
  );
}
